import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import '../../assets/css/dashboard.scss'
import newRequest from '../../assets/images/Leaves&Attendance/newRequest.svg'
import totalRequest from '../../assets/images/Leaves&Attendance/totalPresent.svg'
import pendingRequest from '../../assets/images/Leaves&Attendance/pendingRequest.svg'
import rejectLeaves from '../../assets/images/Leaves&Attendance/rejectLeaves.svg'
import Main from '../Main'
import Download from '../MainSection/Download/Download'
import BarChart from '../Graphs/BarChart'
import RelationshipTypeChart from '../Graphs/RelationshipTypeChart'
import FunnelChart from '../Graphs/FunnelChart'
import LicenceSpliteUpChart from '../Graphs/LicenceSpliteUpChart'
import AssignedModules from '../Graphs/AssignedModules'
import AttendanceStatusChart from '../Graphs/AttendanceStatusChart'
import HolidaySchedules from '../Graphs/HolidaySchedules'
import CustomerStatusChart from '../Graphs/CustomerStatusChart'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadCompanyDropdownData, loadLeaveDashboardCardData, loadLeaveStatusChartData, loadUserDropdownData } from '../../redux/action'
import Skeleton from 'react-loading-skeleton'
import loader from '../../../src/assets/images/Dashboard/loader.gif'

function AttendanceAndLeavesDashboard() {

    const currentYear = new Date().getFullYear();

    const labels = ['Approved', 'Rejected', 'Pending'];
    const colors = [
        'rgba(58, 201, 119, 1)',  // Approved
        'rgba(240, 207, 43, 1)', // Pending
        'rgba(255, 94, 94, 1)', // Rejected
    ];
    const data = [20, 30, 50];

    let dispatch = useDispatch();
    const location = useLocation();

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedUserId = signInDetails ? signInDetails[0].UserID : null
    const storedUserName = signInDetails ? signInDetails[0].UserName : null
    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { leaveStatusChart = [] } = useSelector((state) => state.data);
    const { getUserDropdown } = useSelector((state) => state.data);
    const { leaveDashboardCardData } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(false);
    const [selectedDashboardID, setSelectedDashboardID] = useState(null);

    const [selectedOptionForLeaveStatus, setSelectedOptionForleaveStatus] = useState({
        userId: null || storedUserId,
        user: '' || storedUserName,
        monthId: null,
        month: '',
        year: currentYear || 'Year'
    });

    // Function to generate an array of years from 2020 to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear();  // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
        dispatch(loadUserDropdownData());
        // dispatch(loadLeaveStatusChartData());
    }, [])

    useEffect(() => {
        setLoading(true);
        dispatch(loadLeaveDashboardCardData(setLoading));
    }, [])

    const attendenceLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // const datasets = [
    //     {
    //         type: 'bar',
    //         label: 'Pending',
    //         data: [15, 18, 13, 22, 20, 25, 21, 22, 20, 15, 18, 22],
    //         backgroundColor: 'rgba(240, 207, 43, 1)',
    //         borderColor: 'rgba(240, 207, 43, 1)',
    //         borderWidth: 1,
    //         borderRadius: 4,
    //         barThickness: 8,
    //         borderSkipped: false,
    //     },
    //     {
    //         type: 'bar',
    //         label: 'Rejected',
    //         data: [5, 10, 5, 10, 5, 10, 5, 10, 5, 10, 5, 10],
    //         backgroundColor: 'rgba(255, 94, 94, 1)',
    //         borderColor: 'rgba(255, 94, 94, 1)',
    //         borderWidth: 1,
    //         borderRadius: 4,
    //         barThickness: 8,
    //         borderSkipped: false,
    //     },
    //     {
    //         type: 'line',
    //         label: 'Approved',
    //         data: [10, 12, 18, 15, 14, 15, 18, 16, 18, 14, 16, 17],
    //         backgroundColor: (context) => {
    //             const chart = context.chart;
    //             const ctx = chart.ctx;
    //             const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
    //             gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
    //             gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
    //             return gradient;
    //         },
    //         borderColor: 'rgba(58, 201, 119, 1)',
    //         borderWidth: 2,
    //         fill: true,
    //         tension: 0.4,
    //     }
    // ];

    // Extract month names for labels
    const statusLabels = leaveStatusChart?.map(m => m.MonthName);

    // Function to get data for a specific status
    function getStatusData(status) {
        return leaveStatusChart.map(month => {
            const found = month.LeaveDetails.find(ld => ld.Status === status);
            return found ? found.TotalLeaves : 0;
        });
    }

    // Build datasets dynamically
    const datasets = [
        {
            type: 'bar',
            label: 'Pending',
            data: getStatusData('Pending'),
            backgroundColor: 'rgba(240, 207, 43, 1)',
            borderColor: 'rgba(240, 207, 43, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Rejected',
            data: getStatusData('Rejected'),
            backgroundColor: 'rgba(255, 94, 94, 1)',
            borderColor: 'rgba(255, 94, 94, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'line',
            label: 'Approved',
            data: getStatusData('Approved'),
            backgroundColor: (context) => {
                const chart = context.chart;
                const ctx = chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
                gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
                gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
                return gradient;
            },
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
        }
    ];

    // Final Chart.js config
    const config = {
        type: 'bar',
        data: {
            labels,
            datasets
        },
        options: {
            responsive: true,
            scales: {
                y: { beginAtZero: true }
            }
        }
    };

    // Function to generate an array of years from 2020 to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear();  // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const monthDropdown = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
    ];

    const dropdownOptions = {
        // user: {
        //     default: 'User Name',
        //     items: getUserDropdown,
        // },
        ...(signInDetails?.[0]?.SignInType !== "User" && {
            user: {
                default: 'User Name',
                items: getUserDropdown,
            },
        }),
        month: {
            default: 'Month',
            items: monthDropdown,
        },
        year: {
            default: 'Year',
            items: generateYearRange(2024),
        },
    };

    const navigate = useNavigate();
    const handleBack = () => {
        const moduleId = 4;
        navigate('/leaves', { state: { moduleId } })
    };

    const handleNavigation = () => {
        navigate('/leaves')
    }

    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }

    const handleSelect = (eventKey, type, graphType) => {
        let selectedOption = null;

        if (graphType === 'leaveStatus') {
            let dropdownData;
            let stateSetter;

            if (graphType === 'leaveStatus') {
                dropdownData =
                    type === 'user' ? getUserDropdown :
                        type === 'month' ? monthDropdown :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForleaveStatus;
            }
            // Find the selected option
            if (dropdownData && dropdownData.length > 0) {
                selectedOption = dropdownData.find(item => item.value === Number(eventKey)); // Convert to number
            }

            if (selectedOption) {
                // Update state with the selected option
                const updateData = { ...selectedOption };
                if (type === 'user') {
                    stateSetter(prev => ({
                        ...prev,
                        user: selectedOption.label,
                        userId: selectedOption.value
                    }));
                } else if (type === 'month') {
                    stateSetter(prev => ({
                        ...prev,
                        monthId: selectedOption.value,
                        month: selectedOption.label
                    }));
                } else if (type === 'year') {
                    stateSetter(prev => ({
                        ...prev,
                        year: selectedOption.value
                    }));
                }
            } else {
                console.log(`No ${type} found matching the eventKey`);
            }
        }
    };

    useEffect(() => {
        // if (selectedOptionForLeaveStatus.userId || selectedOptionForLeaveStatus.monthId || selectedOptionForLeaveStatus.year) {
        if (location.pathname === '/attendanceDashboard') {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadLeaveStatusChartData(selectedOptionForLeaveStatus.userId, selectedOptionForLeaveStatus.monthId, selectedOptionForLeaveStatus.year));
        }
    }, [selectedOptionForLeaveStatus, dispatch]);

    const determineColumnSize = (visibleCols) => {
        if (visibleCols === 1) {
            return 12;  // One column takes the full width
        } else if (visibleCols === 2) {
            return 6;  // Two columns each take half the width
        } else if (visibleCols === 3) {
            return 4;  // Three columns each take a third of the width
        } else if (visibleCols >= 4) {
            return 3;  // Four or more columns each take a quarter of the width
        }
        return 4;  // Default fallback
    };

    return (
        <div className='dashboard-container'>
            <Main>
                {loading ? (
                    <div className="loading-container" style={{ position: 'absolute', top: '40%', left: '40%' }}>
                        <img src={loader} style={{ width: '180px' }} />
                    </div>
                ) : (
                    <>
                        <div className='components-download-container'>
                            <Download
                                moduleName="Attendance & Leaves Dashboard"
                                showBackButton={true}
                                showDashboardLibraryButton={true}
                                showSaveCustomViewButton={true}
                                showCustomViewDropdown={true}
                                showAnalyticsButton={false}
                                showDownloadDropdown={true}
                                onBackClick={handleBack}
                                onClick={handleDashboardLibraryClick}
                                customViews={customViews}
                                onCustomDashboardSelect={setSelectedDashboardID}
                            />
                        </div>
                        {/* <Row className='dashboard-cards-container'>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>{leaveDashboardCardData[0]?.CardHeader}</p>
                                <b>{leaveDashboardCardData[0]?.TotalLeaves}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                <img src={pendingRequest} alt="Customer Under Validity" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols' onClick={handleNavigation}>
                        <div className='dashboard-cards'>
                            <div className='dashboard-cards-counts'>
                                <p>{leaveDashboardCardData[1]?.CardHeader}</p>
                                <b>{leaveDashboardCardData[1]?.TotalLeaves}</b>
                            </div>
                            <div className='dashboard-cards-image'>
                                <img src={newRequest} alt="Total Customers" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>{leaveDashboardCardData[2]?.CardHeader}</p>
                                <b>{leaveDashboardCardData[2]?.TotalLeaves}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                <img src={rejectLeaves} alt="Customer License Expiration" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='p-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>{leaveDashboardCardData[3]?.CardHeader}</p>
                                <b>{leaveDashboardCardData[3]?.TotalLeaves}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                <img src={rejectLeaves} alt="Customer License Expiration" />
                            </div>
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-cards-container'>
                            { // Case 1: customViews is empty → show all cards
                                (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                    <>
                                        {/* Total Customer */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'>
                                                <div className='dashboard-cards-counts'>
                                                    <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[0]?.CardHeader}</p>
                                                    <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[0]?.TotalLeaves}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                    <img src={pendingRequest} alt="Customer Under Validity" />
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'>
                                                <div className='dashboard-cards-counts'>
                                                    <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[1]?.CardHeader}</p>
                                                    <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[1]?.TotalLeaves}</b>
                                                </div>
                                                <div className='dashboard-cards-image'>
                                                    <img src={newRequest} alt="Total Customers" />
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'>
                                                <div className='dashboard-cards-counts'>
                                                    <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[2]?.CardHeader}</p>
                                                    <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[2]?.TotalLeaves}</b>
                                                </div>
                                                {/* <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                <img src={totalRequest} alt="Active/Inactive" />
                                            </div> */}
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                    <img src={rejectLeaves} alt="Customer License Expiration" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Customer License Expiration */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'>
                                                <div className='dashboard-cards-counts'>
                                                    <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[3]?.CardHeader}</p>
                                                    <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[3]?.TotalLeaves}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                    <img src={rejectLeaves} alt="Customer License Expiration" />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                ) : (
                                    // Case 2: customViews is not empty → show based on GraphLibraryID
                                    customViews?.map((view, viewIndex) => {

                                        return view.Graphs?.map((graph, index) => {
                                            if (graph.GraphLibraryID === 39) {
                                                return (
                                                    <Col key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'>
                                                            <div className='dashboard-cards-counts'>
                                                                <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[0]?.CardHeader}</p>
                                                                <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[0]?.TotalLeaves}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                                <img src={pendingRequest} alt="Customer Under Validity" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 40) {
                                                return (
                                                    <Col key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'>
                                                            <div className='dashboard-cards-counts'>
                                                                <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[1]?.CardHeader}</p>
                                                                <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[1]?.TotalLeaves}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image'>
                                                                <img src={newRequest} alt="Total Customers" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 41) {
                                                return (
                                                    <Col key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'>
                                                            <div className='dashboard-cards-counts'>
                                                                <p>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[2]?.CardHeader}</p>
                                                                <b>{loading ? <Skeleton width={100} /> : leaveDashboardCardData[2]?.TotalLeaves}</b>
                                                            </div>
                                                            {/* <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                        <img src={totalRequest} alt="Active/Inactive" />
                                                    </div> */}
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                                <img src={rejectLeaves} alt="Customer License Expiration" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 42) {
                                                return (
                                                    <Col key={index} className="p-0 pe-3 ps-1 dashboard-cards-cols">
                                                        <div className="dashboard-cards">
                                                            <div className='dashboard-cards-counts'>
                                                                <p>{leaveDashboardCardData[3]?.CardHeader}</p>
                                                                <b>{leaveDashboardCardData[3]?.TotalLeaves}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                                <img src={rejectLeaves} alt="Customer License Expiration" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            return null; // If no matching GraphLibraryID, return nothing
                                        });
                                    })
                                )}
                        </Row>
                        {/* <Row className='m-0 attendence-leaves-chart-div'>
                    <Col md={9} className='p-0 attendence-leaves-chart-col-div'>
                        <Row className='dashboard-charts'>
                            <Col md={8} className='dashboard-charts-div p-0'>
                                <div className='charts-container'>
                                    <AttendanceStatusChart
                                        moduleName="Status"
                                        labels={attendenceLabels}
                                        datasets={datasets}
                                        dropdownOptions={dropdownOptions}
                                        // defaultSelection={{ user: 'User Name', month: 'Month', year: 'Year' }}
                                        selectedOption={selectedOptionForLeaveStatus}
                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'leaveStatus')}
                                    />
                                </div>
                            </Col>
                            <Col md={4} className='dashboard-charts-div p-0'>
                                <div className='charts-container'>
                                    <RelationshipTypeChart
                                        moduleName="Overall"
                                        labels={labels}
                                        colors={colors}
                                        data={data}
                                        showYear={true}
                                        // showCompany={true}
                                        showApprover={true}
                                        showMonth={true}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className='dashboard-charts pt-4 pb-4 pe-0'>
                            <Col md={8} className='dashboard-charts-div p-0'>
                                <div className='charts-container'>
                                    <BarChart
                                        moduleName="Leave Type"
                                        showTypeNameMonth={true}
                                        showYear={true}
                                        label="Leave Type"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} className='dashboard-charts-div attendence-leaves-calender-container p-0'>
                        <div className='attendence-leaves-container'>
                            <HolidaySchedules />
                        </div>
                    </Col>
                </Row> */}

                        <Row className='m-0 attendence-leaves-chart-div'>
                            <Col md={9} className='p-0 attendence-leaves-chart-col-div'>
                                {/* Top Row Charts */}
                                <Row className='dashboard-charts'>
                                    {(() => {
                                        const chartsToRender = (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false))
                                            ? [
                                                {
                                                    id: 43, component:

                                                        (<div className='charts-container  pe-2 ps-1'> <AttendanceStatusChart
                                                            moduleName="Status"
                                                            labels={attendenceLabels}
                                                            datasets={datasets}
                                                            dropdownOptions={dropdownOptions}
                                                            selectedOption={selectedOptionForLeaveStatus}
                                                            handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'leaveStatus')}
                                                        /></div>), colSize: 8
                                                },
                                                {
                                                    id: 46, component: (<div className='charts-container  pe-2 ps-1'> <RelationshipTypeChart
                                                        moduleName="Overall"
                                                        labels={labels}
                                                        colors={colors}
                                                        data={data}
                                                        showYear
                                                        showApprover
                                                        showMonth
                                                    /></div>), colSize: 4
                                                },
                                            ]
                                            : customViews.flatMap(view => {
                                                const visibleGraphs = view.Graphs?.filter(graph => [43, 46].includes(graph.GraphLibraryID)) || [];
                                                return visibleGraphs.map(graph => {
                                                    let chartComponent = null;
                                                    switch (graph.GraphLibraryID) {
                                                        case 43:
                                                            chartComponent = <AttendanceStatusChart
                                                                moduleName="Status"
                                                                labels={attendenceLabels}
                                                                datasets={datasets}
                                                                dropdownOptions={dropdownOptions}
                                                                selectedOption={selectedOptionForLeaveStatus}
                                                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'leaveStatus')}
                                                            />;
                                                            break;
                                                        case 46:
                                                            chartComponent = <RelationshipTypeChart
                                                                moduleName="Overall"
                                                                labels={labels}
                                                                colors={colors}
                                                                data={data}
                                                                showYear
                                                                showApprover
                                                                showMonth
                                                            />;
                                                            break;
                                                    }
                                                    return { id: graph.GraphLibraryID, component: chartComponent, colSize: graph.GraphLibraryID === 43 ? 8 : 4 };
                                                });
                                            });

                                        return chartsToRender.map(({ id, component, colSize }) => (
                                            <Col key={id} md={colSize} className='dashboard-charts-div p-0'>
                                                <div className='charts-container'>{component}</div>
                                            </Col>
                                        ));
                                    })()}
                                </Row>

                                {/* Second Row Chart */}
                                <Row className='dashboard-charts pt-4 pb-4 pe-0'>
                                    {(() => {
                                        const barChart = (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false))
                                            ? [{ id: 47, component: <BarChart moduleName="Leave Type" showTypeNameMonth showYear label="Leave Type" />, colSize: 8 }]
                                            : customViews.flatMap(view => {
                                                const visibleGraphs = view.Graphs?.filter(graph => graph.GraphLibraryID === 47) || [];
                                                return visibleGraphs.map(graph => ({
                                                    id: graph.GraphLibraryID,
                                                    component: <BarChart moduleName="Leave Type" showTypeNameMonth showYear label="Leave Type" />,
                                                    colSize: 8
                                                }));
                                            });

                                        return barChart.map(({ id, component, colSize }) => (
                                            <Col key={id} md={colSize} className='dashboard-charts-div p-0'>
                                                <div className='charts-container'>{component}</div>
                                            </Col>
                                        ));
                                    })()}
                                </Row>
                            </Col>

                            {/* Right Column Calendar */}
                            <Col md={3} className='dashboard-charts-div attendence-leaves-calender-container p-0'>
                                <div className='attendence-leaves-container'>
                                    <HolidaySchedules />
                                </div>
                            </Col>
                        </Row>
                    </>
                )}
            </Main>
        </div>
    )
}

export default AttendanceAndLeavesDashboard
